import React from 'react';
import { CircularProgress } from '@mui/material';
import Countdown from 'react-countdown';

interface WaitingForApprovalProps {
  maxPollingInterval: number;
  isWaiting: boolean;
  onSuccess?: boolean;
  hasTimedOut?: boolean;
  startTime: number;
  onTimeout: () => void;
}

const SECOND_DIVIDER = 1000;

const WaitingForApproval: React.FC<WaitingForApprovalProps> = ({
  maxPollingInterval,
  isWaiting,
  onSuccess,
  hasTimedOut,
  startTime,
  onTimeout
}) => {
  if (!isWaiting || onSuccess || hasTimedOut) {
    return null;
  }

  const renderer = ({ minutes, seconds, completed }: { minutes: number, seconds: number, completed: boolean }) => {
    if (completed) {
      onTimeout();
      return null;
    }

    const totalSeconds = minutes * 60 + seconds;
    const progress = (totalSeconds / (maxPollingInterval / SECOND_DIVIDER)) * 100;

    return (
      <div className="text-center">
        <div className="mb-4 relative inline-block">
          <CircularProgress 
            variant="determinate" 
            value={progress} 
            size={75}
            thickness={4}
            color="primary"
          />
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
            <span className="text-lg font-semibold">
              {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            </span>
          </div>
        </div>
        <p className="text-md font-medium">Please confirm on your handset.</p>
      </div>
    );
  };

  // Ensure we have a valid startTime
  if (!startTime) {
    return null;
  }

  return (
    <Countdown
      date={startTime + maxPollingInterval}
      renderer={renderer}
      intervalDelay={1000}
      precision={1}
    />
  );
};

export default WaitingForApproval; 